import { devError } from './devLog';
import { axiosRequest } from './axiosHttp';

export const axiosPost = (collectionName, formData, config) =>
  axiosRequest('post', collectionName, formData, config).catch((err) => {
    devError('axiosPost failed:', err);
  });
